<ng-container>
  <div @fadeIn>
    <h2>Comunidades en la biblioteca del COAM</h2>
   <div class="row">
        <div class="col-4 p-4 text-md-center">
            <a target="_self" href="/handle/123456789/28" target="_self">
                <img src="/server/api/core/bitstreams/adc22788-95c8-4c01-8262-5930a8ecb616/content" width="100%" style="max-height: 95px;">
                <div class="lead item-list-title mt-2">Fondo Antiguo</div>
            </a>
        </div>
        <div class="col-4 p-4 text-md-center">
            <a target="_self" href="/handle/123456789/29" target="_self">
                <img src="/server/api/core/bitstreams/5e8a43c6-db97-4c49-974b-2e7eb5d2ef67/content" width="100%" style="max-height: 95px;">
                <div class="lead item-list-title mt-2">Publicaciones de la institución</div>
            </a>
        </div>
        <div class="col-4 p-4 text-md-center">
            <a target="_self" href="/handle/123456789/30" target="_self">
                <img src="/server/api/core/bitstreams/92118e87-2404-47ea-827f-7f73eb7835a3/content" width="100%" style="max-height: 95px;">
                <div class="lead item-list-title mt-2">Trabajos de investigación </div>
            </a>
        </div>
   </div>
  </div>
</ng-container>
